import {
  RECEIVE_SCHEDULE_DATA,
  NO_RESULTS_SCHEDULE_DATA,
  RESET_NO_RESULTS_SCHEDULE_DATA,
  REQUESTED_SCHEDULE_DATA,
  ERROR_RETRIEVING_SCHEDULE_DATA,
  REQUEST_SCHEDULE_DATA
} from "../actions/schedulesDataActions";

const initialState = {
  items: [],
  noResults: false,
  segmentTypes: [],
  notFoundTrackingIds: [],
  requestedScheduleData: false,
  error: null
};

export default function (state = initialState, action) {

  switch (action.type) {
    case REQUEST_SCHEDULE_DATA:
      return {
          ...state,
          isFetching: true
      };
    case RECEIVE_SCHEDULE_DATA:
      return {
        ...state,
        error: null,
        items: action.payload.unrestricted_routes,
        segmentTypes: action.payload.segmentTypes,
        noResults: false,
        requestedScheduleData: true,
        isFetching: false
      };
    case NO_RESULTS_SCHEDULE_DATA:
      return {
        ...initialState,
        error: null,
        noResults: true,
        requestedScheduleData: false,
        isFetching: false
      };
    case RESET_NO_RESULTS_SCHEDULE_DATA:
      return {
        ...state,
        error: null,
        items: [],
        segmentTypes: [],
        noResults: false,
        requestedScheduleData: true,
        isFetching: false
      };
    case REQUESTED_SCHEDULE_DATA:
      return {
        ...state,
        error: null,
        requestedScheduleData: true,
        isFetching: false
      };
    case ERROR_RETRIEVING_SCHEDULE_DATA:
      return {
        ...initialState,
        error: action.payload,
        requestedScheduleData: false,
        isFetching: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scheduleReducer.js